import { I18n } from '@calendly/i18n'

import {
  ErrorIcon,
  IconWrapper,
} from 'features/reporting'

import { TileCard } from './tile'

export const ErrorState = () => (
  <TileCard
    as="a"
    href="/app/organization/reporting"
    isError
  >
    <IconWrapper>
      <ErrorIcon />
    </IconWrapper>
    <strong>{I18n.t('publisher.organization.reporting.titles.load_error')}</strong>
    <span>{I18n.t('publisher.organization.reporting.errors.load_error')}</span>
  </TileCard>
)
